module.exports = __webpack_public_path__ + "803b24ab17c0aaa0072070e0a93a1cc7.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/team/CarolinaMastretta.png
// module id = 429
// module chunks = 0